module.exports = __webpack_public_path__ + "static/media/referencePointOn.3c9d1639.svg";